import { store } from "../../redux/store";
import fetchServer from "../fetchServer";
// import { oneWayRis } from "./tempFlightData";
// import { roundTripRis } from "./tempFlightData2";

export default async function getMyGDSOffers(obj, userId, onDownloadProgress,cancelToken) {
  var result = { return: 0, msg: "Error", data: [] };

  const userData = store.getState().user.userData;
  let token = userData?.agent?.token || userData.accessToken;
  let headers = { Authorization: `Bearer ${token}` };

    
  // let flightType = 'One Way';
  // const destiny = obj?.destinations;
  // if(destiny?.length > 1)
  //   if(destiny?.length === 2)
  //     if(destiny?.at(0)?.departureLocation === destiny?.at(-1)?.arrivalLocation)
  //       flightType = 'Return';
  //     else flightType = 'Multi City'


  // return flightType === 'One Way' ? {return: 1,msg: 'success',data: {data: oneWayRis?.data?.data?.map(obj => ({...obj,supplier: 'my'+obj?.supplier}))}} 
  //   : {return: 1,msg: 'success',data: {data: roundTripRis?.data?.data?.map(obj => ({...obj,supplier: 'my'+obj?.supplier}))}}

  
  if (userId) headers["user-id"] = userId;
  await fetchServer({
    method: "POST",
    url: `/product/v1/flight/myGdsOffers`,
    data: obj,
    headers,
    cancelToken,
    onDownloadProgress
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data.data };
        }
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result["msg"] = "Network Error!";
        result["error"] = "Please check your connection.";
      }
    });

  return result;
}
